import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { AccountInfoService } from '~core/modules/identity/services/account-info.service';
import { LoadUserInfoSuccess, UserLogout } from './user-info.actions';

@Injectable({
  providedIn: 'root'
})
export class UserInfoEffects {
  constructor(
    private accountInfoService: AccountInfoService,
  ) {}

  @Effect()
  updateDataOnAuthChanged$: Observable<Action> = this.accountInfoService.getAccountInfo().pipe(
    map(user => user ? new LoadUserInfoSuccess({user}) : new UserLogout()),
  );
}
